<template>
  <el-popover
      placement="left-start"
  >
    <template #reference>
      <div class="contact_box">
        <svg t="1762847829456" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
             p-id="3493" width="30" height="30">
          <path
              d="M856 504.576a55.84 55.84 0 0 0-48 16.256V480a296 296 0 0 0-592 0h-48C168 290.016 322.016 136 512 136S856 290.016 856 480v24.576z m-26.56 172.256A344.096 344.096 0 0 1 512 888v-48c131.264 0 242.56-85.44 281.344-203.744 4.224 18.912 18.016 34.24 36.064 40.576z"
              fill="#ffffff" p-id="3494"></path>
          <path d="M512 864m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#ffffff" p-id="3495"></path>
          <path
              d="M848 456a104 104 0 0 1 104 104v64a104 104 0 0 1-208 0v-64a104 104 0 0 1 104-104z m0 48a56 56 0 0 0-56 56v64a56 56 0 0 0 112 0v-64a56 56 0 0 0-56-56zM176 456a104 104 0 0 1 104 104v64a104 104 0 0 1-208 0v-64a104 104 0 0 1 104-104z m0 48a56 56 0 0 0-56 56v64a56 56 0 0 0 112 0v-64a56 56 0 0 0-56-56z"
              fill="#ffffff" p-id="3496"></path>
        </svg>
      </div>
    </template>
    <template #default>
      <el-image style="width: 160px; height: auto" :src="imgUrl" :fit="'fit'"/>
    </template>
  </el-popover>
</template>

<script setup>
import imgUrl from "../Contact/contact.jpg"

</script>

<style lang="less" scoped>
.contact_box {
  cursor: pointer;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0a84ff;
  border-radius: 50%;
  //background: red;
  position: fixed;
  right: 40px;
  bottom: 100px;
  z-index: 99999;
}
</style>